<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12 col-sm-8">
          <h1 class="d-none d-sm-block">{{ reportTitle }}</h1>
          <h2 class="d-block d-sm-none">{{ reportTitle}}</h2>
        </div>
        <div class="col-12 col-sm-2">
          Show
          <div class="btn-group dropdown-group">
            <button class="btn btn-secondary btn-rounded dropdown-toggle dropdown-button" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{pageAmount}} results
            </button>
            <div class="dropdown-menu dropdown-menu-custom">
              <span class="dropdown-item text-info" v-on:click="pageAmount = 10; $refs.reportTable.refresh()">10 results</span>
              <a class="dropdown-item text-info" v-on:click="pageAmount = 25; $refs.reportTable.refresh()">25 results</a>
              <a class="dropdown-item text-info" v-on:click="pageAmount = 50; $refs.reportTable.refresh()">50 results</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-2 filter-input">
          <input class="btn btn-rounded btn-light" v-model="filterValue" @keyup="updateFilter" :placeholder="$t('Search actions')"/>
        </div>
      </div>
    </div>
    <div class="card-body">
      <table-component :data="fetchReportData" v-if="reportDataLoaded" ref="reportTable" class="hide-filter">
        <table-column v-for="columnHeader in columnHeaders" :label="formatHeader(columnHeader.name)"
                      :show="columnHeader.name" v-bind:key="columnHeader.name" :data-type="columnHeader.type"></table-column>

      </table-component>
    </div>
  </div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  export default {
    name: "Report",
    data: function () {
      return {
        reportId: "",
        reportTitle: "",
        reportData: [],
        paginationSettings: {
          totalPages: 0,
          currentPage: 0
        },
        columnHeaders: [],
        reportDataLoaded: false,
        pageAmount: 10,
        filterValue: ""
      }
    },
    created: function () {
      let vm = this;
      let PAGE_AMOUNT = this.pageAmount;
      this.reportId = this.$route.params.id;
      APIHelper.getResource("/api/report/" + this.reportId).then(function (data) {
        vm.reportData = data.Results;

        let keys = Object.keys(vm.reportData[0]);

        for (let i = 0; i < keys.length; i++) {
          let header = {};
          if (!isNaN(Number(vm.reportData[0][keys[i]]))) {
            header = {
              'name': keys[i],
              'type': 'numeric'
            }
          } else {
            header = {
              'name': keys[i],
              'type': undefined
            }
          }

          vm.columnHeaders.push(header);
        }

        // for (let i = 0; i < vm.reportData.length; i++) {
        //   for (let j = 0; j < keys.length; j++) {
        //     if (!isNaN(Number(vm.reportData[i][keys[j]]))) {
        //       vm.reportData[i][keys[j]] = Number(vm.reportData[i][keys[j]]);
        //     }
        //   }
        // }

        // for (let key in vm.reportData[0]) {
        //   if (vm.reportData[0].hasOwnProperty(key)) {
        //     vm.columnHeaders.push(key);
        //   }
        // }
        vm.reportTitle = data.name;
        vm.$parent.$emit("addTitleBreadcrumb", vm.reportTitle);
        vm.reportDataLoaded = true;
        vm.paginationSettings.totalPages = Math.ceil(vm.reportData.length / PAGE_AMOUNT);
      });
    },
    methods: {
      updateFilter: function () {
        if (typeof this.$refs.reportTable !== "undefined") {
          this.$refs.reportTable.filter = this.filterValue;
        }
      },
      formatHeader: function (header) {
        return header.replace("_", " ");
      },
      fetchReportData({page, filter, sort}) {
        let PAGE_AMOUNT = this.pageAmount;
        let pageData = this.reportData.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);
        let paginationData = {
          totalPages: this.paginationSettings.totalPages,
          currentPage: page
        };
        pageData = this.filterAndSort(pageData, filter, sort);
        return {data: pageData, pagination: paginationData}
      },
      sortByProperty(property, direction){
        let directionCoeff = direction === "asc" ? 1 : -1;

        return function (a, b) {
          let sortA = (a[property] === null || typeof a[property] === 'undefined') ? a[property] : a[property].toLowerCase();
          let sortB = (b[property] === null || typeof b[property] === 'undefined') ? b[property] : b[property].toLowerCase();

          if(sortA < sortB) {
            return -1 * directionCoeff;
          }

          if(sortA > sortB){
            return directionCoeff;
          }
          return 0;
        }
      },
      filterAndSort(data, filter, sortObj) {
        let output = [];
        // First filter
        for (let i = 0; i < data.length; i++) {
          let item = data[i];

          let added = false;
          for (let key in item) {
            // Disregard prototype properties
            if (!item.hasOwnProperty(key)) continue;

            if (item[key] !== null && item[key].toString().toLowerCase().includes(filter.toLowerCase()) && !added) {
              output.push(item);
              added = true;
            }
          }
        }

        // Then sort:
        output.sort(this.sortByProperty(sortObj.fieldName, sortObj.order));
        return output;
      },
      beforeDestroy() {
        this.$parent.$emit("removeTitleBreadcrumb");
      }
    }
  }

</script>

<style>
  .dropdown-button {
    background-color: #64748d;
    color: white;
  }

  .dropdown-group {
    margin-right: 10px;
    margin-left: 10px;
  }

  .dropdown-item {
    font-weight: bold;
  }

  .dropdown-menu-custom {
    position: absolute;
    transform: translate3d(0px, -130px, 0px);
    top: 5px !important;
    left: 7px !important;
    will-change: transform;
    border-radius: 10px !important;
    min-width: initial !important;
  }

  .filter-input > input {
    border-color: #ddd;
    text-align: left;
    font-weight: 600;
  }
  .table-component__table__body > tr > td{
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 15px;
  }

  .table-component__table__body > tr > td > i{
    font-size: 20px;
  }

  .table-component__table__body > tr:nth-child(even){
    background-color: #f5f7fb;
  }

  @media (max-width: 768px) {
    .filter-input{
      margin-top: 8px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Report.vue